import { render } from "./info.component.vue?vue&type=template&id=87210cc2&ts=true"
import script from "./info.component.vue?vue&type=script&lang=ts"
export * from "./info.component.vue?vue&type=script&lang=ts"

import "./info.component.vue?vue&type=style&index=0&id=87210cc2&lang=scss"

import exportComponent from "/Users/brian/VIS Solutions/aeon-boxed-middleware-spa/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__